import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, CardTitle, Spinner, Table } from "reactstrap";
import Button from "react-bootstrap/Button";

import { apiFetch, API } from "../../services/api";
import { apiErrorMessage } from "../../helpers/security";
import { pushSummary, pushCardState, GHOST_COUNTER_LABEL } from "../../helpers/pushStats";

// Bloc « Push » : livraison réelle des notifications (accusés de réception),
// jetons sains / fantômes. Un seul appel par changement de période.
export function PushHealthCard() {
    const [days, setDays] = useState(7);
    const [stats, setStats] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setStats(null);
        setError(null);
        apiFetch(API.back + "/push-stats?days=" + days, { market: false, method: "GET" })
            .then((res) =>
                res.ok ? res.json() : res.text().then((b) => Promise.reject(new Error(apiErrorMessage(res.status, b))))
            )
            .then((data) => {
                if (cancelled) return;
                setStats(data);
                setError(null);
            })
            .catch((err) => {
                if (cancelled) return;
                setError("Statistiques push indisponibles (" + err.message + ").");
            });
        return () => {
            cancelled = true;
        };
    }, [days]);

    const state = pushCardState(stats, error);
    const s = state === "ready" ? pushSummary(stats) : null;

    return (
        <Card className="flex-fill w-100 mb-3">
            <CardHeader>
                <div className="d-flex justify-content-between align-items-start flex-wrap">
                    <div>
                        <CardTitle tag="h5" className="mb-1">
                            Push
                        </CardTitle>
                        <div className="text-muted small">Livraison réelle des notifications</div>
                    </div>
                    <div>
                        {[7, 30].map((d) => (
                            <Button
                                key={d}
                                size="sm"
                                className="mr-1"
                                variant={days === d ? "dark" : "outline-secondary"}
                                onClick={() => setDays(d)}
                            >
                                {d} j
                            </Button>
                        ))}
                    </div>
                </div>
            </CardHeader>
            <CardBody>
                {error ? <div className="alert alert-danger">{error}</div> : null}
                {state === "loading" ? <Spinner color="primary" size="sm" /> : null}
                {s ? (
                    <div>
                        <div className="d-flex flex-wrap mb-3">
                            <div className="mr-5">
                                <div className="h3 mb-0">{s.overall.rate}</div>
                                <div className="text-muted small">Livraison globale · {s.overall.sent} envois</div>
                            </div>
                            <div className="mr-5">
                                <div className="h3 mb-0">{s.healthy}</div>
                                <div className="text-muted small">Jetons sains</div>
                            </div>
                            <div>
                                <div className="h3 mb-0">{s.ghosts}</div>
                                <div className="text-muted small">{GHOST_COUNTER_LABEL}</div>
                            </div>
                        </div>
                        {s.delivery.length > 0 ? (
                            <Table size="sm" responsive className="mb-2">
                                <thead>
                                    <tr>
                                        <th>Plateforme</th>
                                        <th>Envois</th>
                                        <th>Accusés reçus</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {s.delivery.map((d) => (
                                        <tr key={d.label}>
                                            <td>{d.label}</td>
                                            <td>{d.sent}</td>
                                            <td>{d.delivered}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        ) : null}
                        <p className="text-muted small mb-1">
                            Les push de l'app iPhone/Android n'envoient pas d'accusé : ils apparaissent en « Sans accusé ».
                        </p>
                        {s.warnings.map((w, i) => (
                            <div key={i} className="alert alert-warning py-1 mb-1 small">
                                {w}
                            </div>
                        ))}
                    </div>
                ) : null}
            </CardBody>
        </Card>
    );
}
